var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadingDot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10.1493,
    height: 10,
    viewBox: "0 0 10.1493 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.07463 10C7.87727 10 10.1493 7.76142 10.1493 5C10.1493 2.23858 7.87727 0 5.07463 0C2.27199 0 0 2.23858 0 5C0 7.76142 2.27199 10 5.07463 10Z",
    fill: "#CB009F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading-dot.b03c3af9e167fd3de52ed1ffd2d92971.svg";